import React from 'react';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import FormLabel from '@material-ui/core/FormLabel';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useTranslation } from 'react-i18next';
import Excel from 'exceljs';
import ApiService from '../../services/ApiService';
import useStyles from './styles';

const FileSaver = require('file-saver');

export default function PlannedPredictionPage() {
  const classes = useStyles();
  const { t } = useTranslation();
  const [loading, setLoading] = React.useState(false);

  function saveFile(data) {
    const workbook = new Excel.Workbook();
    const worksheet = workbook.addWorksheet('Planned Prediction');

    const headers = [];
    headers.push({ header: 'WagonNumber', key: 'wagonNumber' });
    headers.push({ header: 'Revision Date', key: 'revisionDate' });
    headers.push({ header: 'RG Date', key: 'rgDate' });
    headers.push({ header: 'Keeper', key: 'keeper' });
    headers.push({ header: 'Business Unit', key: 'businessUnit' });
    headers.push({ header: 'Contract Number', key: 'contractNumber' });
    headers.push({ header: 'Product Type', key: 'productType' });
    headers.push({ header: 'Expected Status', key: 'expectedStatus' });
    headers.push({ header: 'Criticity', key: 'criticity' });

    worksheet.columns = headers;

    data.forEach((details) => {
      const row = {};
      row.wagonNumber = details.wagonNumber;
      row.revisionDate = details.revisionDate;
      row.rgDate = details.rgDate;
      row.keeper = details.keeper;
      row.businessUnit = details.businessUnit;
      row.contractNumber = details.contractNumber;
      row.productType = details.productType;
      row.expectedStatus = details.expectedStatus;
      row.criticity = details.criticity;

      worksheet.addRow(row);
    });

    workbook.xlsx
      .writeBuffer()
      .then((buffer) =>
        FileSaver.saveAs(new Blob([buffer]), 'Planned Prediction.xlsx'),
      )
      .catch((err) => {
        setLoading(false);
        console.log('Error writing excel export', err);
      });
  }

  function downloadFile() {
    setLoading(true);
    ApiService.getAllPlannedPrediction()
      .then((response) => {
        saveFile(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log('downloading error', error);
        setLoading(false);
      });
  }

  return (
    <div className={classes.root}>
      {loading && (
        <Paper elevation={0} position="absolute" zindex="2">
          <CircularProgress className={classes.loader} />
        </Paper>
      )}
      <Grid container spacing={0}>
        <Typography className={classes.title}>
          {t('revision_plan_checker')}
        </Typography>
        <Paper elevation={0} className={classes.contentPaper}>
          <Grid
            spacing={0}
            direction="column"
            alignItems="center"
            justifyContent="center"
            item
            xs={12}
            className={classes.gridMarginSmall}
          >
            <div>
              <FormLabel className={classes.titleBlack}>
                {t('download prediction')}
              </FormLabel>
              <div className={classes.contentCriticityDescription}>
                <ul>
                  <li>
                    <p>
                      <b>{t('good')}</b>
                      {t('colon') + t('ticket_rev_date')} <b>{t('or')}</b>
                      {t('rev_date_empty')}
                    </p>
                  </li>
                  <li>
                    <p>
                      <b>{t('bad')}</b> {t('colon') + t('bad_rev_date')}
                    </p>
                  </li>
                  <ul>
                    <li>
                      <p>
                        <b>{t('high_criticity')}</b>
                        {t('colon') + t('bad_high_criticity')}
                      </p>
                    </li>
                    <li>
                      <p>
                        <b>{t('low_criticity')}</b>
                        {t('colon') + t('bad_low_criticity')}
                      </p>
                    </li>
                  </ul>
                  <li>
                    <p>
                      <b>{t('UNKNOWN')}</b> {t('colon') + t('unknown_rev_date')}
                    </p>
                  </li>
                  <ul>
                    <li>
                      <p>
                        <b>{t('high_criticity')}</b>
                        {t('colon') + t('unknown_high_criticity')}
                      </p>
                    </li>
                    <li>
                      <p>
                        <b>{t('low_criticity')}</b>
                        {t('colon') + t('unknown_low_criticity')}
                      </p>
                    </li>
                  </ul>
                </ul>
              </div>
              <div className={classes.fileDownloadButton}>
                <Box>
                  <Button
                    disabled={loading}
                    onClick={downloadFile}
                    color="secondary"
                    variant="contained"
                    fullWidth
                  >
                    {t('download')}
                  </Button>{' '}
                </Box>
              </div>
            </div>
          </Grid>
        </Paper>
      </Grid>
    </div>
  );
}
